import React from "react";

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { FormControlLabel, IconButton, Radio } from "@mui/material";

export default function AdditinalDetails(props:any) {

    const { details } = props;

    return (
        <div style={{ boxSizing: 'border-box' }}>
            <div className="ad-main-container">
                <div className="ad-left-container">
                    <div className="ad-ispection-req-container" style={{ padding: '40px 24px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="text-3E3E3E-18px">Inspection Requirements</span>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {
                                    Object.keys(details['inspectionRequirement']).map((title: string, index: number) => {
                                            return (
                                                <div key={index} style={{ width: 'auto', display: 'flex', flexDirection: 'column', marginTop: '24px', marginRight: '32px', wordBreak: 'break-all' }}>
                                                    <span style={{ marginBottom: '12px' }} className="text-787878-14px">{title}</span>
                                                    <span className="text-303030-16px">{details['inspectionRequirement'][title]}</span>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="ad-ispection-req-container" style={{ padding: '40px 24px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="text-3E3E3E-18px">Inspection Criteria</span>
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px' }}>
                                <span style={{ marginBottom: '8px' }} className="text-787878-14px">Exterior Inspection</span>
                                <span className="text-303030-14px preserve-newlines">{details['inspectionCriteria']['exteriorInspection']}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px' }}>
                                <span style={{ marginBottom: '8px' }} className="text-787878-14px">Interior Inspection</span>
                                <span className="text-303030-14px preserve-newlines">{details['inspectionCriteria']['interiorInspection']}</span>
                            </div>
                        </div>
                    </div>
                    <div className="ad-ispection-req-container" style={{ padding: '40px 24px', borderBottom: 'none' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="text-3E3E3E-18px">Code of Compliance</span>
                            <div style={{ display: 'flex' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px', marginRight: '40px' }}>
                                    <span style={{ marginBottom: '12px' }} className="text-787878-14px">Code of Compliance is Required</span>
                                    <span className="text-303030-16px">{details['codeOfCompliance']['isCodeOfComplianceRequired']}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px', marginRight: '40px' }}>
                                    <span className="text-787878-14px">Common Code Violations</span>
                                    {
                                        details['codeOfCompliance']['commonCodeViolations'] ?
                                        <div onClick = {()=>{
                                            let url = details['codeOfCompliance']['commonCodeViolations'];
                                            if(url){
                                                if(!url.includes("http://") && !url.includes("https://")){
                                                    url = "https://"+url;
                                                }
                                                window.open(url, '_blank')
                                            }

                                        }}>
                                            <span className="text-3576E5-14px">Open Link</span>
                                            <IconButton>
                                                <OpenInNewIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                            </IconButton>
                                        </div>
                                        : <div className="text-303030-16px" style={{marginTop:"12px"}}>N/A</div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="ad-right-container">
                    <div style={{ padding: '40px 24px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span className="text-3E3E3E-18px">Rental Certificate</span>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {
                                    Object.keys(details['rentalCertificate']).map((title: string, index:number) => {

                                        return (
                                            <div key={index} style={{ marginTop: '24px' }}>
                                                <span className="text-5B5B5B-14px">{title}</span>
                                                <div style={{ marginTop: '19px' }}>
                                                    <FormControlLabel control={<Radio checked={details['rentalCertificate'][title] ==='Yes' } disabled />} label={<span id='text-3E3E3E-14px'>Yes</span>} />
                                                    <FormControlLabel control={<Radio checked={details['rentalCertificate'][title] ==='No' } disabled />} label={<span id='text-3E3E3E-14px'>No</span>} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}